<template>
  <div>
    <el-dialog
      title="订单详情"
      :visible.sync="orderDetails"
      :close-on-click-modal="false"
      top="3vh"
      width="1200px">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <template>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="基础信息" name="first">
                <div class="title-box"><span class="txt1">基础信息</span></div>
                <div class="title-cont">
                  <div class="fr3">
                    <div class="fr3-body">订单编码：23512836428472</div>
                    <div class="fr3-body">快递方式：待审核</div>
                    <div class="fr3-body">订单状态：发错了</div>
                    <div class="fr3-body">创建时间：这是一条备注</div>
                    <div class="fr3-body">付款时间：2024-12-12  12:12:00</div>
                    <div class="fr3-body">关联售后订单：<span class="blueColor">452550550525585</span></div>
                  </div>
                </div>
                <div class="title-box"><span class="txt1">申请人信息</span></div>
                <div class="title-cont">
                  <div class="fr3">
                    <div class="fr3-body">申请人：张三（游客）</div>
                    <div class="fr3-body">手机号:1827899876</div>
                    <div class="fr3-body">所属区域：四川省成都市武侯区</div>
                  </div>
                </div>
                <div class="title-box"><span class="txt1">申请人从属关系</span></div>
                <div class="title-cont">
                  <div class="fr1">
                    <div class="fr1-body">
                      技术线：
                      <span class="blueColor">张三【技术老师】</span>
                      <span>--</span>
                      <span class="blueColor">张三【技术老师】</span>
                      <span>--</span>
                      <span class="blueColor">张三【技术老师】</span>
                    </div>
                    <div class="fr1-body">
                      业务线：
                      <span class="blueColor">张三【技术老师】</span>
                      <span>--</span>
                      <span class="blueColor">张三【技术老师】</span>
                      <span>--</span>
                      <span class="blueColor">张三【技术老师】</span>
                    </div>
                    <div class="fr1-body">城市公司：第一城市公司</div>
                  </div>
                </div>
                <div class="title-box"><span class="txt1">支付信息</span></div>
                <div class="title-cont">
                  <div class="fr3">
                    <div class="fr3-body">补差金额：￥20.00</div>
                  </div>
                </div>
                <div class="fr3">
                    <div class="fr3-body fr3-body-txt">支付方式：</div>
                </div>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="date" label="支付方式" align="center" width="600">
                    </el-table-column>
                    <el-table-column prop="name" label="支付金额" align="center">
                    </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="物流信息" name="second">
                <div class="title-box"><span class="txt1">收货信息</span></div>
                <div class="title-cont">
                  <div class="fr3">
                    <div class="fr3-body">收货人姓名：张三</div>
                    <div class="fr3-body">收货人联系方式：235612784214</div>
                    <div class="fr3-body">联系人地址：四川省成都市武侯区益州大道西二街</div>
                  </div>
                </div>
                <div class="title-box"><span class="txt1">暂无物流信息</span></div>
                <div class="title-cont">
                  <!-- 没有物流信息 -->
                  <el-empty description="该售后订单暂无物流信息～"></el-empty>
                  <!-- 有物流 -->
                  <div class="fr3">
                    <div class="fr3-body">物流信息：</div>
                  </div>
                  <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="date" label="包裹" width="180">
                    </el-table-column>
                    <el-table-column prop="name" label="寄件人" width="180">
                    </el-table-column>
                    <el-table-column prop="address" label="快递编号"> </el-table-column>
                    <el-table-column prop="address" label="发货时间"> </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button
                          @click="handleClick(scope.row)"
                          type="text"
                          size="small"
                          >查看物流</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="title-box"><span class="txt1">发货信息</span></div>
                <div class="title-cont">
                  <!-- 没有发货信息 -->
                  <el-empty description="暂无发货信息～"></el-empty>
                  <!-- 有物流 -->
                  <div class="fr3">
                    <div class="fr3-body">发货信息：</div>
                  </div>
                  <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="date" label="商品" width="180">
                    </el-table-column>
                    <el-table-column prop="name" label="规格" width="180">
                    </el-table-column>
                    <el-table-column prop="address" label="聚水潭规格编号"> </el-table-column>
                    <el-table-column prop="address" label="下单数量（件）"> </el-table-column>
                    <el-table-column prop="address" label="是否为预售"> </el-table-column>
                    <el-table-column prop="address" label="预售商品距离预计发货时间还剩（天）"> </el-table-column>
                    <el-table-column prop="address" label="已发数量（件）"> </el-table-column>
                    <el-table-column prop="address" label="待发数量（件）"> </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
              <el-tab-pane label="订单详情" name="three">
                <div class="title-box"><span class="txt1">基础信息</span></div>
                <div class="title-cont">
                  <div class="fr3">
                    <div class="fr3-body">收货人姓名：张三</div>
                    <div class="fr3-body">收货人联系方式：235612784214</div>
                    <div class="fr3-body">联系人地址：四川省成都市武侯区益州大道西二街</div>
                  </div>
                </div>
                <div class="title-box"><span class="txt1">商品列表</span></div>
                <div class="title-cont">
                  <div class="fr3">
                    <div class="fr3-body">商品列表：</div>
                  </div>
                  <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="date" label="序号" width="180">
                    </el-table-column>
                    <el-table-column prop="name" label="商品名称" width="180">
                    </el-table-column>
                    <el-table-column prop="address" label="规格"> </el-table-column>
                    <el-table-column prop="address" label="聚水潭规格编码"> </el-table-column>
                    <el-table-column prop="address" label="市场价"> </el-table-column>
                    <el-table-column prop="address" label="数量"> </el-table-column>
                    <el-table-column prop="address" label="小计"> </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      orderDetails: false,
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
  },
  methods: {
    handleSeeDetails() {
      this.orderDetails = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 10px 0;
  .txt1 {
    font-size: 16px;
    color: #000000;
    position: relative;
    padding-left: 10px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
.title-cont {
  padding: 10px 20px;
  .fr3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr3-body {
      width: 33.33%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
  .fr1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr1-body {
      width: 100%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
}
.fr3-body-txt{
  padding: 10px 20px;
}
.blueColor {
  color: #1596cd !important;
}
.box-title {
  display: flex;
  justify-content: space-between;
}
</style>
